import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const LoginPage = lazy(() => import("./LoginPage"));

const LoginPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <LoginPage />
    </Suspense>
  );
};

export default LoginPageLazy;
